export enum BranchUrlParameters {
  PROMO_CODE = 'promo_code',
  REFERRAL_CODE = 'referral_code'
}
